module.exports = __webpack_public_path__ + "img/african-grand-lodge.366deadd.png";